import React from 'react';
import { Box, Button, Grid, Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { PlanActionStepStatus } from 'src/constants/actionPlan';

import { styles } from './index.styles';

const Step = ({
  actionButtonLabel = null,
  actionButtonOnClick = null,
  actionPlanCount,
  active,
  description,
  disabled = false,
  inactive,
  label,
  onClick,
  state,
  step,
}) => (
  <Grid item sx={styles.step} xs={3}>
    <Typography variant="h3" component="div" sx={styles.stepCounter}>
      {step + 1}
    </Typography>
    <Stack
      direction="row"
      sx={{
        width: '100%',
        position: 'relative',
      }}
    >
      {step > 0 && <Box sx={styles.arrow} />}

      <Button
        sx={styles.button}
        variant="cta"
        color="tertiary"
        disabled={
          step < state - 1 ||
          step > state ||
          disabled ||
          (step === PlanActionStepStatus.DIALOG - 1 &&
            state === PlanActionStepStatus.DIALOG &&
            actionPlanCount > 0)
        }
        onClick={onClick}
        data-test-id={`follow-up-button-${label.split(' ')[0]}`}
      >
        <img
          src={state > step ? active : inactive}
          alt={`Step ${label}: ${state > step ? 'active' : 'inactive'}`}
        />
      </Button>
    </Stack>
    <Typography
      variant="h3"
      sx={{
        fontWeight: 'normal',
        mb: 2,
      }}
    >
      {label}
    </Typography>
    <Typography
      variant="h5"
      component="div"
      sx={{
        fontWeight: 'normal',
      }}
    >
      {description}
    </Typography>
    {actionButtonOnClick && actionButtonLabel && (
      <Box
        sx={{
          pt: 5,
        }}
      >
        <Button variant="cta" color="tertiary" onClick={actionButtonOnClick}>
          {actionButtonLabel}
        </Button>
      </Box>
    )}
  </Grid>
);

Step.propTypes = {
  actionButtonLabel: PropTypes.string,
  actionButtonOnClick: PropTypes.func,
  actionPlanCount: PropTypes.number.isRequired,
  active: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  inactive: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  state: PropTypes.number.isRequired,
  step: PropTypes.number.isRequired,
};

export default Step;
